const initializedSelectors = new Set();

/**
 * Initialize delegated expandable info icon behaviour for Gutenberg block content.
 */
export function initExpandableInfoIcon({
  buttonSelector,
  titleSelector = '',
  showLabel = '',
  hideLabel = '',
  transitionMs = 300,
}) {
  const initializerKey = `${buttonSelector}|${titleSelector}`;
  if (!buttonSelector || initializedSelectors.has(initializerKey)) {
    return;
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(buttonSelector);

    if (button) {
      event.preventDefault();
      toggleInfo(button, { showLabel, hideLabel, transitionMs });
      return;
    }

    if (!titleSelector) {
      return;
    }

    const title = event.target.closest(titleSelector);
    if (!title) {
      return;
    }

    const titleButton = title.querySelector(buttonSelector);
    if (!titleButton) {
      return;
    }

    event.preventDefault();
    toggleInfo(titleButton, { showLabel, hideLabel, transitionMs });
  });

  initializedSelectors.add(initializerKey);
}

function toggleInfo(button, options) {
  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  const contentId = button.getAttribute('aria-controls');
  const content = document.getElementById(contentId);

  if (!content) {
    return;
  }

  if (isExpanded) {
    closeInfo(button, content, options);
  } else {
    openInfo(button, content, options);
  }
}

function openInfo(button, content, { hideLabel }) {
  button.setAttribute('aria-expanded', 'true');
  button.classList.add('is-expanded');
  updateButtonText(button, hideLabel);
  content.hidden = false;

  requestAnimationFrame(() => {
    content.style.maxHeight = `${content.scrollHeight}px`;
  });
}

function closeInfo(button, content, { showLabel, transitionMs }) {
  button.setAttribute('aria-expanded', 'false');
  button.classList.remove('is-expanded');
  updateButtonText(button, showLabel);
  content.style.maxHeight = `${content.scrollHeight}px`;
  content.offsetHeight;
  content.style.maxHeight = '0';

  setTimeout(() => {
    if (button.getAttribute('aria-expanded') === 'false') {
      content.hidden = true;
    }
  }, transitionMs);
}

function updateButtonText(button, text) {
  if (!text) {
    return;
  }

  const label = button.querySelector('.visually-hidden');
  if (label) {
    label.textContent = text;
  }
}
